module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "border-radius": "15px",
      "border": "5px solid #000 !important"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "d-flex justify-center py-2"
  }, [_c('v-icon', {
    attrs: {
      "color": "blacknew"
    }
  }, [_vm._v("mdi-circle-medium")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0",
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card', {
    staticClass: "py-2",
    attrs: {
      "flat": "",
      "color": "#f3f5f7"
    }
  }, [_c('div', {
    staticClass: "font-weight-600 blacknew--text mb-2 font-size-18 px-4 py-2"
  }, [_vm._v("\n                " + _vm._s(_vm.preview.mapel) + "\n            ")]), _vm._v(" "), (_vm.preview.wacana) ? _c('v-card', {
    staticClass: "ma-0 mb-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-body-2 black--text"
  }, [(!!_vm.preview.wacana) ? _c('p', {
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseLatex(_vm.preview.wacana))
    }
  }) : _vm._e()])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "mx-0 mb-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "text-body-2 black--text",
    staticStyle: {
      "white-space": "pre-line"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parseLatex(_vm.preview.soal))
    }
  })])], 1)], 1), _vm._v(" "), (
    _vm.preview.tipe_pilihan === 'single' ||
    _vm.preview.tipe_pilihan === 'multiple' ||
    _vm.preview.tipe_pilihan === 'truefalse'
  ) ? _c('v-card', {
    staticClass: "mx-0 my-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-item', {
    staticStyle: {
      "min-height": "none !important"
    },
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "font-weight-bold black--text pa-0"
  }, [_vm._v("\n                                Pilihan Jawaban\n                            ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.preview.pilihan), function(jawaban, i) {
    return (
      _vm.preview.tipe_pilihan === 'single' ||
      _vm.preview.tipe_pilihan === 'multiple'
    ) ? _c('v-card', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (jawaban.value),
        expression: "jawaban.value"
      }],
      key: i,
      staticClass: "mx-4 my-2 mb-3",
      attrs: {
        "elevation": "0",
        "color": "#f3f5f7"
      }
    }, [_c('div', {
      staticClass: "pa-2 d-flex align-center",
      class: jawaban.answer === true ?
        'bg-success text-white' :
        'blacknew--text',
      attrs: {
        "cols": "1"
      }
    }, [_c('span', {
      staticClass: "font-weight-bold px-2 mr-1",
      class: jawaban.answer === true ?
        'white--text' :
        'primary--text'
    }, [_vm._v("\n                                " + _vm._s(jawaban.key) + "\n                            ")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.parseLatex(jawaban.value))
      }
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.preview.tipe_pilihan === 'truefalse') ? _c('div', {
    staticClass: "mx-4 my-2 mb-4"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "cellpadding": "10"
    }
  }, [_c('tr', {
    staticStyle: {
      "background-color": "#f3f5f7"
    }
  }, [_c('td', {
    staticClass: "pa-3",
    attrs: {
      "width": "60%"
    }
  }, [_vm._v("Pernyataan")]), _vm._v(" "), _c('td', {
    staticClass: "pa-3",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Benar")]), _vm._v(" "), _c('td', {
    staticClass: "pa-3",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Salah")])]), _vm._v(" "), _vm._l((_vm.preview.pilihan), function(jawaban, i) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (jawaban.value),
        expression: "jawaban.value"
      }],
      staticStyle: {
        "border-top": "1px solid #ebebeb"
      }
    }, [_c('td', {
      staticClass: "pa-3",
      attrs: {
        "width": "40%"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.parseLatex(jawaban.value))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "pa-3 text-center",
      class: jawaban.answer === true ?
        'bg-success text-white' :
        'bg-error'
    }, [(jawaban.answer) ? _c('v-icon', {
      staticStyle: {
        "font-size": "20px"
      },
      attrs: {
        "color": "white"
      }
    }, [_vm._v("\n                                        mdi-check-circle\n                                    ")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "pa-3 text-center",
      class: !jawaban.answer ?
        'bg-success text-white' :
        'bg-error'
    }, [(!jawaban.answer) ? _c('v-icon', {
      staticStyle: {
        "font-size": "20px"
      },
      attrs: {
        "color": "white"
      }
    }, [_vm._v("\n                                        mdi-check-circle\n                                    ")]) : _vm._e()], 1)])
  })], 2)]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.preview.tipe_pilihan === 'inputtext') ? _c('v-card', {
    staticClass: "mx-0 my-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-item', {
    staticStyle: {
      "min-height": "none !important"
    },
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "font-weight-bold black--text pa-0"
  }, [_vm._v("\n                                Jawaban\n                            ")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.parseLatex(_vm.preview.key))
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "mx-0 my-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-item', {
    staticStyle: {
      "min-height": "none !important"
    },
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "font-weight-bold black--text pa-0"
  }, [_vm._v("\n                                Pembahasan\n                            ")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.parseLatex(_vm.preview.explanation))
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-3"
  }, [_c('v-row', [_c('v-col', [_c('v-btn', {
    attrs: {
      "depressed": "",
      "block": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n                    Kembali\n                ")])], 1), _vm._v(" "), _c('v-col', [_c('v-btn', {
    attrs: {
      "color": "blew",
      "dark": "",
      "depressed": "",
      "loading": _vm.loading,
      "block": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('validate')
      }
    }
  }, [_vm._v("\n                    Validasi\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-607dcce6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/itembank/components/Preview.vue
// module id = 1535
// module chunks = 1